import {useRef} from 'react';
import {useTranslation} from 'react-i18next';
import {useUnit} from 'effector-react';
import {useNavigate} from 'react-router-dom';
import {$user, logoutEv} from '../../models/authModel/index.js';
import {Avatar} from 'primereact/avatar';
import {Button} from 'primereact/button';
import {OverlayPanel} from 'primereact/overlaypanel';
import {Tooltip} from 'primereact/tooltip';


export default function UserHeader() {
    const {t} = useTranslation()
    const navigate = useNavigate()

    const overlay = useRef(null)

    const user = useUnit($user)
    const logout = useUnit(logoutEv)

    const initials = user ? (user?.name?.split(' ')?.[0]?.[0] ?? '') + (user?.name?.split(' ')?.[1]?.[0] ?? '') : ''

    return <div className={'flex flex-column align-items-end gap-3 w-full max-h-3rem mb-2'}>
        <Avatar shape={'circle'}
                size={'large'}
                label={initials}
                className={'hover:shadow-4'}
                onClick={(e) => overlay.current.toggle(e)}
        />
        <OverlayPanel ref={overlay}>
                <div className={'flex flex-column gap-3'}>
                    <span className={'text-xl'}>{t('Мой профиль')}</span>
                    <div className={'flex align-items-center gap-4'}>
                        <Avatar label={'FL'} size={'xlarge'} shape={'circle'}/>
                        <div className={'flex flex-column gap-2'}>
                            <span className={'font-bold'}>{user?.name ?? ''}</span>
                            {(user?.groups && user?.groups?.length > 3)
                                ? <div className={'flex gap-2 align-items-end'}>
                                    <span className={'text-sm'}>{user?.groups?.[0] ?? ''}</span>
                                    <Tooltip target={'.user-group-tooltip-icon'}>
                                        <div className={'flex flex-column'}>
                                            {user?.groups?.map((g, idx) => <span key={idx} className={'text-sm'}>{g}</span>)}
                                        </div>
                                    </Tooltip>
                                    <i className={'user-group-tooltip-icon pi pi-ellipsis-h'}
                                       data-pr-position={'left'}
                                       style={{fontSize: 14}}
                                    />
                                </div>
                                : (user?.groups && user?.groups?.length > 0)
                                    ? user?.groups?.map((g, idx) => <span key={idx} className={'text-sm'}>{g}</span>)
                                    : ''}
                            <div className={'flex align-items-center gap-2'}>
                                <div className={'pi pi-envelope'}/>
                                <span>{user?.email ?? ''}</span>
                            </div>
                        </div>
                    </div>
                    <div className={'flex gap-3'}>
                    <Button icon={'pi pi-pencil'} label={t('Редактировать')} outlined onClick={() => navigate('/my-profile')}/>
                    <Button icon={'pi pi-sign-out'} label={t('Выйти')} severity={'warning'} outlined onClick={() => logout()}/>
                    </div>
                </div>
        </OverlayPanel>
    </div>
}